export default __webpack_public_path__ + "static/media/MarketingList@32.839e5960.svg";